import { useState, useCallback } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Plus, UserPlus } from 'lucide-react'
import { columns } from './columns'
import { DataTable } from './data-table'
import { useClinicUsers } from '@/hooks/useClinicUsers'
import { Skeleton } from '@/components/ui/skeleton'
import { ClinicUserDialog } from './ClinicUserDialog'
import { AddInvestorDialog } from './AddInvestorDialog'
import { useViewMode } from '@/stores/viewMode'
import { useMe } from '@/hooks/useMe'

export default function ClinicUsersPage() {
  const { id: clinicId } = useViewMode()
  const { user } = useMe()

  const [page] = useState(1)
  const [pageSize] = useState(10)
  const [account, setAccount] = useState('')
  const [showAddDialog, setShowAddDialog] = useState(false)
  const [showAddInvestorDialog, setShowAddInvestorDialog] = useState(false)

  const isAdmin = user?.role_type === 'sys_admin'

  const { clinicUsers, isLoading, isError, mutate } = useClinicUsers({
    page,
    pageSize,
    clinic_id: clinicId,
    account,
  })

  const handleSearch = useCallback((value: string) => {
    setAccount(value)
  }, [])

  if (isError) {
    return (
      <div>
        <div className="text-center text-destructive">載入診所使用者列表失敗。請稍後再試。</div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div>
        <Skeleton className="h-8 w-[200px] mb-4" />
        <Skeleton className="h-[400px] w-full" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">診所使用者管理</h2>
          <p className="text-muted-foreground mt-2">管理診所使用者帳號</p>
        </div>
        <div className="flex gap-2">
          {isAdmin && (
            <Button variant="outline" onClick={() => setShowAddInvestorDialog(true)}>
              <UserPlus className="mr-2 h-4 w-4" />
              加入投資者
            </Button>
          )}
          <Button onClick={() => setShowAddDialog(true)}>
            <Plus className="mr-2 h-4 w-4" />
            新增診所使用者
          </Button>
        </div>
      </div>

      <Card>
        <CardContent className="p-6">
          <DataTable
            columns={columns}
            data={clinicUsers || []}
            onSearch={handleSearch}
            meta={{
              reloadData: () => mutate(),
            }}
          />
        </CardContent>
      </Card>

      <ClinicUserDialog
        open={showAddDialog}
        onOpenChange={setShowAddDialog}
        clinicId={clinicId}
        onSuccess={() => mutate()}
      />

      <AddInvestorDialog
        open={showAddInvestorDialog}
        onOpenChange={setShowAddInvestorDialog}
        clinicId={clinicId}
        onSuccess={() => mutate()}
      />
    </div>
  )
}
